import { gql } from '@apollo/client'

const importOnDemandVideoMutation = gql`
  mutation ImportOnDemandVideo($id: ID!) {
    importOnDemandVideo(id: $id) {
      result
      errors {
        identifier
        message
        field
      }
      data {
        eta
        etaHumanized
      }
    }
  }
`

export default importOnDemandVideoMutation
